import { FAQ as ZinniaFAQ, FAQProps } from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';
import {
  CTAType,
  SectionName,
  useAvroTracking,
  useTrackEvent,
} from '../../../observability';
import {
  CtaGoal,
  CtaName,
  EventName,
} from '../../../observability/tracking/events';

type Props = {
  heading: string;
  items: {
    title: string;
    content: RichTextHTMLString;
    href?: string;
    isInitiallyOpen?: boolean;
  }[];
  seeMoreHref: string;
  seeMoreText: string;
};

/**
 * This needs to be a seperated component so it properly consumes
 * the context provided by TrackingWrapper.
 */
export function AccordionSection(props: Props) {
  const trackEvent = useTrackEvent();
  const { emitAccordionToggleEvent, emitCTAClickEvent } = useAvroTracking();

  const items: FAQProps['items'] = props.items.map((item) => ({
    title: item.title,
    content: <RichTextHtml html={item.content} />,
    href: item.href,
    isInitiallyOpen: item.isInitiallyOpen,
    onToggle: ({ isOpen }) => {
      emitAccordionToggleEvent({
        option_selected: isOpen ? 'opening' : 'closing',
        section: SectionName.AccordionSection,
        title: item.title,
      });
      trackEvent(
        isOpen ? EventName.FAQ_ACCORDION_OPEN : EventName.FAQ_ACCORDION_CLOSE,
        { title: item.title },
      );
    },
  }));

  const handleCtaClick = () => {
    emitCTAClickEvent({
      href: props.seeMoreHref,
      type: CTAType.cta_button,
      text: props.seeMoreText,
      section: SectionName.AccordionSection,
    });
    trackEvent(EventName.CALL_TO_ACTION, {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: CtaName.moreArticles,
      cta_raw_text: props.seeMoreText,
      cta_goal: CtaGoal.getMoreInformation,
    });
  };

  return (
    <ZinniaFAQ
      ctaHref={props.seeMoreHref}
      ctaText={props.seeMoreText}
      heading={props.heading}
      items={items}
      onCtaClick={handleCtaClick}
    />
  );
}
